import { useEffect, useState } from "react";

import firebase from "./firebase";
import { isDev } from "../helpers";
// Configure FirebaseUI.
export const uiConfig = {
  // Popup signin flow rather than redirect flow.
  signInFlow: "redirect",
  // We will display Google and Facebook as auth providers.
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.EmailAuthProvider.PROVIDER_ID,
  ],
  callbacks: {
    signInSuccessWithAuthResult: () => false,
  },
};

export const logout = () => firebase.auth().signOut();

export const useUser = () => {
  const [user, setUser] = useState({});

  useEffect(() => {
    firebase.auth().onAuthStateChanged((authInfo) => {
      if (isDev)
        console.log("onAuthStateChanged", authInfo, authInfo.isAnonymous);
      setUser({
        isSignedin: !authInfo.isAnonymous,
        uid: authInfo.uid,
        favorite: [],
      });
    });
  }, []);

  useEffect(() => {
    if (!user.uid) return;
    const unsubscribe = firebase
      .firestore()
      .collection(isDev ? "devUsers" : "users")
      .doc(user.uid)
      .onSnapshot((snapshot) => {
        setUser({ ...user, ...snapshot.data() });
      });
    return () => unsubscribe();
  }, [user.uid]);

  return [user, setUser];
};
